export { ClientLabel } from 'labels/components/ClientLabel/ClientLabel'
